<template>
  <transition name="fade">
    <div class="complementary-dialog" v-if="getComplementaryDialogOpen">
      <div class="wrapper">
        <h3>Zmiana w konfiguracji mebla</h3>
        <p>Materac, który już wybrałeś zostanie usunięty z powodu zmiany rozmiaru łóżka.</p>

        <div class="buttons">
          <button type="button" class="cancel" @click="cancelComplementaryDialog">Anuluj</button>
          <button type="button" class="confirm" @click="acceptComplementaryDialog">Kontynuuj</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import {mapGetters} from "vuex";
import ComplementaryDialogMixin from '../../../mixins/complementary-dialog'

export default {
  name: "ComplementaryDialog",
  mixins: [ComplementaryDialogMixin],
  computed: {
    ...mapGetters('customizer', ['getComplementaryDialogOpen'])
  }
}
</script>

<style scoped lang="scss">
.complementary-dialog {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, .5);
  z-index: 9999;

  display: flex;
  justify-content: center;
  align-items: center;

  .wrapper {
    font-family: "neue-haas-grotesk-display", sans-serif;
    padding: 50px;
    background: #fff;
    box-shadow: 0 10px 12px rgba(26, 26, 26, 0.1);
    border-radius: 4px;
    max-width: 450px;

    @media (max-width: 480px) {
      margin: 0 20px;
      padding: 20px;
    }

    h3 {
      font-size: 22px;
      margin: 0 0 15px 0;
    }

    p {
      line-height: 22px;
      font-size: 14px;
    }

    .buttons {
      text-align: right;
      margin: 15px 0 0 0;

      @media (max-width: 480px) {
        display: flex;
        justify-content: space-between;
      }

      button {
        padding: 10px 30px;
        display: inline-flex;
        align-items: center;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 500;
        transition: all .2s;
        cursor: pointer;

        &.confirm {
          background: #252525;
          border: 2px solid #252525;
          color: #fff;

          &:hover {
            background: #303030;
          }
        }

        &.cancel {
          border: 2px solid #252525;
          color: #252525;
          background: #fff;
          margin: 0 15px 0 0;

          &:hover {
            background: #f1f1f1;
          }
        }
      }


    }
  }
}
</style>
